import ExecutionEnvironment from 'exenv';
const NATIVE_APP = /^(MercadoLibre|MercadoPago)-(iOS|Android)(?:\/|%2F)((?:\d+\.){2}\d+)/;
const getNativeApp = () => {
  var _window;
  if (!ExecutionEnvironment.canUseDOM) return;
  const userAgent = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
  const nativeAppArray = NATIVE_APP.exec(userAgent);
  if (!Array.isArray(nativeAppArray)) return;
  return {
    name: nativeAppArray[1],
    os: nativeAppArray[2],
    version: nativeAppArray[3]
  };
};
export { getNativeApp as default };
